import { Store } from "redux"
import { ApplicationState } from "../types"

let store: Store<ApplicationState, any> = null

export const injectStore = (appStore: Store<ApplicationState, any>) => {
    store = appStore
}

export const getStoreState = () => {
    return store ? store.getState() : null
}

export const getStore = () => {
    return store
}
